import { api } from "../utils/axios";

export const getSwapRequest = async () => {
  try {
    const { data, ok } = await api.get(`/swapRequest?page=1&limit=100`);
    if (ok) {
      return { res: data, err: null };
    }
  } catch (error) {
    return { res: null, err: error };
  }
};

export const cancelSwapRequest = async (id: string) => {
  try {
    const { data, ok } = await api.patch(`/swapRequest/${id}/cancel`, {});
    if (ok) {
      return { res: data, err: null };
    } else {
      return { res: null, err: data };
    }
  } catch (error) {
    return { res: null, err: error };
  }
};

export const getEligibleSwaps = async (day: number, month: number, year: number, shiftType: string) => {
  try {
    const { data, ok } = await api.get(
      `/swapProposal/eligible?day=${day}&month=${month}&year=${year}&shiftType=${shiftType}`
    );
    if (ok) return { res: data, err: null };
    return { res: null, err: data };
  } catch (error) {
    return { res: null, err: error };
  }
};

export const proposeSwap = async (params: {
  colleagueId: string;
  requesterShift: { day: number; month: number; year: number; shiftType: string };
  colleagueShift: { day: number; month: number; year: number; shiftType: string };
}) => {
  try {
    const { data, ok } = await api.post(`/swapProposal`, params);
    if (ok) return { res: data, err: null };
    return { res: null, err: data };
  } catch (error) {
    return { res: null, err: error };
  }
};

export const getSwapProposals = async () => {
  try {
    const { data, ok } = await api.get(`/swapProposal`);
    if (ok) return { res: data, err: null };
    return { res: null, err: data };
  } catch (error) {
    return { res: null, err: error };
  }
};

export const respondToSwapProposal = async (id: string, action: "accept" | "reject") => {
  try {
    const { data, ok } = await api.patch(`/swapProposal/${id}/${action}`, {});
    if (ok) return { res: data, err: null };
    return { res: null, err: data };
  } catch (error) {
    return { res: null, err: error };
  }
};

export const createSwapRequest = async (params: any) => {
  try {
    const { data, ok } = await api.post(`/swapRequest`, params);
    if (ok) {
      return { res: data, err: null };
    } else {
      return { res: null, err: data };
    }
  } catch (error) {
    return { res: null, err: error };
  }
};
